"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.osmosisAddressToBuffer = void 0;
const tslib_1 = require("tslib");
const bech32_1 = require("bech32");
const tiny_invariant_1 = (0, tslib_1.__importDefault)(require("tiny-invariant"));
const osmosisAddressToBuffer = (osmosisAddress) => {
    (0, tiny_invariant_1.default)(osmosisAddress.length == 43, `invalid osmosis address length ${osmosisAddress.length} (expected 43)`);
    const words = bech32_1.bech32.decode(osmosisAddress).words;
    (0, tiny_invariant_1.default)(words.length == 160 / 5, `invalid length ${osmosisAddress.length} (expected 32)`);
    return Buffer.from(bech32_1.bech32.fromWords(words));
};
exports.osmosisAddressToBuffer = osmosisAddressToBuffer;
//# sourceMappingURL=osmosisAddress.js.map